import { Language, getLanguage, text } from "../utils/i18n";

export type ProjectLocalizationOriginalString = {
  string: string;
  /**
   * Whether the string is too generic to replace as-is, and requires
   * a sweet-i18n context.
   */
  requiresContext: boolean;
}

export type ProjectLocalizationOriginalStringObject = {
  order: ProjectLocalizationOriginalString[];
}

export class ProjectLocalization {
  private static _originalStrings: ProjectLocalizationOriginalStringObject | null = null;
  private static _originalStringsLanguage: Language | null = null;

  static getOriginalStrings(): ProjectLocalizationOriginalStringObject {
    const language = getLanguage();

    if (ProjectLocalization._originalStrings && ProjectLocalization._originalStringsLanguage === language) {
      //  Since we can replace translations, we must cache the object. Otherwise, the returned object will
      //  use the replaced translations.
      //  This assumes translations are changed after invoking this function,
      //  as well as that changing language requires a page reload.
      return ProjectLocalization._originalStrings;
    }

    ProjectLocalization._originalStringsLanguage = language;

    //  Dessa ska vara på originalspråket till i18n-filen.
    return ProjectLocalization._originalStrings = {
      order: [
        { string: 'order', requiresContext: false },
        { string: 'ordern', requiresContext: false },
        { string: 'ordrar', requiresContext: false },
        { string: 'ordrarna', requiresContext: false },
        { string: 'en order', requiresContext: false },
        { string: 'ny order', requiresContext: false },
        { string: 'lägg till', requiresContext: true },
        { string: 'ordinarie datum', requiresContext: false },
        { string: 'lagt', requiresContext: true },
      ]
    };
  }

  /**
   * Match with result of `getOrderOriginalStrings`.
   */
  readonly order: string[] = [];

  constructor(deriveFrom?: Partial<ProjectLocalization>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }
  }

  isEmpty() {
    return !this.order.find(string => string);
  }
}